import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { CommonService } from './shared/commonService';
import { ApiServices } from './services/api.services';
import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  NgClickOutsideDirective,
  NgClickOutsideExcludeDirective,
} from 'ng-click-outside2';
import { provideToastr } from 'ngx-toastr';
import { AgilToastComponent } from './shared/toaster/agil-toast/agil-toast.component';
import { HomeService } from './rwa/home.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
export function initializeApp(translate: TranslateService) {
  return () => {
    const browserLang = translate.getBrowserLang();
    translate.setDefaultLang(browserLang || 'en');
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    CommonService,
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [TranslateService],
      multi: true
    },
    ApiServices,
    HttpClient,
    provideHttpClient(withFetch()),
    provideAnimations(),
    HomeService,
    provideToastr({
      timeOut: 5500,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      enableHtml: true,
      progressBar: true,
      toastComponent: AgilToastComponent,
    }),
  ],
};
